/** Badge color per HSK level */
export const HSK_COLORS = {
  1: "bg-green-100 text-green-700",
  2: "bg-lime-100 text-lime-700",
  3: "bg-yellow-100 text-yellow-700",
  4: "bg-orange-100 text-orange-700",
  5: "bg-red-100 text-red-700",
  6: "bg-purple-100 text-purple-700",
};

/** Human-readable SRS level names (index = srsLevel 0-5) */
export const SRS_LABELS = ["Mới", "Cơ bản", "Sơ cấp", "Trung cấp", "Nâng cao", "Thành thạo"];

/** HSK level options for <select> filter (empty string = all) */
export const HSK_FILTER_LEVELS = ["", "1", "2", "3", "4", "5", "6"];

/** HSK level options for form <select> (numbers only) */
export const HSK_FORM_LEVELS = [1, 2, 3, 4, 5, 6];
